import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import PortalApp from './PortalApp';
import MoveApp from './MoveApp';
import FieldApp from './FieldApp';
import KioskPublicApp from './KioskPublicApp';
import { AuthProvider } from './context/AuthContext';
import './theme.css';

const path = window.location.pathname;
const isPortal = path.startsWith('/portal');
const isMove = path.startsWith('/move');
const isField = path.startsWith('/field');
const isKiosk = path.startsWith('/kiosk');

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    {isKiosk ? <KioskPublicApp /> : isMove ? <MoveApp /> : isPortal ? <PortalApp /> : isField ? (
      <AuthProvider><FieldApp /></AuthProvider>
    ) : (
      <AuthProvider><App /></AuthProvider>
    )}
  </React.StrictMode>
);
